import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import { AuthProvider } from "@/context/AuthContext";
import HomePage from "@/pages/HomePage";
import ListPage from "@/pages/ListPage";
import PostDetailPage from "@/pages/PostDetailPage";
import SubmitPage from "@/pages/SubmitPage";
import { LoginPage, RegisterPage } from "@/pages/AuthPages";
import AdminPage from "@/pages/AdminPage";
import MySubmissionsPage from "@/pages/MySubmissionsPage";
import AboutPage from "@/pages/AboutPage";
import AccountPage from "@/pages/AccountPage";

function App() {
  return (
    <HelmetProvider>
      <AuthProvider>
        <BrowserRouter>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#0A0A0A",
              color: "#F9F9F8",
              border: "1px solid #0A0A0A",
              borderRadius: 0,
              fontFamily: "IBM Plex Mono, monospace",
              fontSize: 12,
              letterSpacing: "0.05em",
              textTransform: "uppercase",
            },
          }}
        />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/editorials" element={<ListPage type="essay" title="Editorials" subtitle="Opinion and analysis on media and journalism" hideTopics cardLabel="Editorial" />} />
          <Route path="/leaders" element={<ListPage title="Leaders" subtitle="Latest published" hideTopics />} />
          <Route path="/debates" element={<ListPage type="forum" title="Debates" subtitle="Join the discussion in our forums on the articles posted here" cardLabel="Debate" />} />
          <Route path="/interviews" element={<ListPage type="interview" title="Interviews" subtitle="Shared views and experiences" hideTopics />} />
          <Route path="/essays" element={<ListPage type="essay" title="Essays & Opinion" subtitle="Long-form arguments from citizens. Read, disagree, respond." />} />
          <Route path="/forums" element={<ListPage type="forum" title="Public Forums" subtitle="Threaded discussions on the questions that matter. Add your reply." />} />
          <Route path="/polls" element={<ListPage type="poll" title="User Surveys" subtitle="Add your votes and see what others think" hideTopics />} />
          <Route path="/post/:id" element={<PostDetailPage />} />
          <Route path="/submit" element={<SubmitPage />} />
          <Route path="/my-submissions" element={<MySubmissionsPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/account" element={<AccountPage />} />
        </Routes>
      </BrowserRouter>
      </AuthProvider>
    </HelmetProvider>
  );
}

export default App;
